var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.962,
    height: 46.438,
    viewBox: "0 0 38.962 46.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8829",
    "data-name": "Path 8829",
    d: "M29.459,14.832H24.025a3.069,3.069,0,0,0-2.162-2.625L25.2,7.064a1.422,1.422,0,1,0-.953-.618l-3.521,5.422a6.619,6.619,0,0,0-2.494,0L11.9,2.117a1.375,1.375,0,1,0-1.158.635,1.382,1.382,0,0,0,.205-.017l6.15,9.472a3.069,3.069,0,0,0-2.162,2.625H9.5a9.5,9.5,0,0,0-9.5,9.5V34.788a9.507,9.507,0,0,0,7.125,9.2c-.043.774-.064,2.447.557,2.447.549,0,1.459-1.309,1.986-2.147H29.295c.526.838,1.436,2.147,1.986,2.147.621,0,.6-1.673.557-2.447a9.507,9.507,0,0,0,7.125-9.2V24.335a9.5,9.5,0,0,0-9.5-9.5M27.521,38.739H6.469A1.867,1.867,0,0,1,4.6,36.872V22.262A1.867,1.867,0,0,1,6.469,20.4H27.521a1.867,1.867,0,0,1,1.867,1.867v14.61a1.867,1.867,0,0,1-1.867,1.867m5.84-3.317a2.21,2.21,0,1,1,2.21-2.21,2.21,2.21,0,0,1-2.21,2.21m0-8.558a2.21,2.21,0,1,1,2.21-2.21,2.21,2.21,0,0,1-2.21,2.21",
    fill: "#444242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTv);
export default __webpack_public_path__ + "static/media/tv.2cabd25f09b1637ef7211917be6d15c7.svg";
export { ForwardRef as ReactComponent };